// Alert.stories.js|jsx

import classNames from 'class-names';
import PropTypes from 'prop-types';
import React from 'react';
import { Alert } from 'react-bootstrap';

import Icon from '../../Atoms/Icon/Icon';

export const AlertSeverityTypes = {
  important: {
    color: 'white',
    bgColor: 'red',
    icon: 'danger',
  },
  warning: {
    color: 'white',
    bgColor: 'orange',
    icon: 'danger',
  },
  success: {
    color: 'white',
    bgColor: 'green',
    icon: 'check-mark',
  },
};

export const AlertSeverity = ({
  severity,
  className,
  icon,
  children,
  ...props
}) => {
  const type = AlertSeverityTypes[severity.toLowerCase()];
  return (
    <Alert
      variant={severity.toLowerCase()}
      {...props}
      className={classNames(className, {
        [`py-1 bg-${type.bgColor} text-${type.color}`]: true,
      })}
    >
      {icon === true ? (
        <Icon name={type.icon} className="mr-2 align-text-top" />
      ) : (
        icon || ''
      )}
      {children || severity.toUpperCase()}
    </Alert>
  );
};

AlertSeverity.propTypes = {
  severity: PropTypes.oneOf(Object.keys(AlertSeverityTypes)),
  className: PropTypes.string,
  icon: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.bool,
  ]),
  children: PropTypes.node,
};

AlertSeverity.defaultProps = {
  severity: 'important',
  icon: true,
};
